<template>
  <div>
    <div class="flex flex-col gap-12" :data-qa="question.key">
      <RevCheckbox
        v-for="option in question.options"
        :id="option.inputId"
        :key="option.inputId"
        v-model="selectedValues"
        :data-qa="`${question.key}-${option.value}`"
        :value="option.value"
        variant="full"
      >
        <template #label>{{ option.label }}</template>
      </RevCheckbox>
    </div>

    <RevButton
      class="mt-24"
      :disabled="selectedValues.length === 0"
      full-width="always"
      variant="primary"
      @click="emit('answer', question.key, selectedValues)"
    >
      {{ i18n(translations.confirm) }}
    </RevButton>

    <button
      class="body-1-bold mt-16 w-full cursor-pointer underline"
      type="button"
      @click="emit('answer', question.key, '0')"
    >
      {{ i18n(translations.noneOfThese) }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCheckbox } from '@ds/components/Checkbox'

import type { RenderQuestion } from '~/scopes/buyback/composables/useFunnelQuestions'

import translations from './QuestionsFormCheckbox.translations'

const props = defineProps<{
  question: RenderQuestion
  checkboxModel: string | string[] | false
}>()

const emit = defineEmits<{
  (event: 'answer', key: string, value: string[] | string): void
}>()

const i18n = useI18n()

const selectedValues = ref<string[]>(
  Array.isArray(props.checkboxModel) ? [...props.checkboxModel] : [],
)
</script>
